/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Speakers_Metrics_Words_SuffixInputs */



/**
* | output |
* | --- |
* | "{name} Words" |
*
* @param {Speakers_Metrics_Words_SuffixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_metrics_words_suffix = /** @type {((inputs: Speakers_Metrics_Words_SuffixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Metrics_Words_SuffixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.name} Words`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} Words`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.name} Words`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.name} Words`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.name} Words`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.name} Words`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} Words`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} Words`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.name} Words`)
	return /** @type {LocalizedString} */ (`${i?.name} Words`)
});